
export const autoplayOverlay = {
  title: "Reprodução Automática",
  description: "Configure opções de reprodução automática",
  enableAutoplay: "Ativar reprodução automática",
  countdownDuration: "Duração da contagem regressiva",
  showCountdown: "Exibir contagem regressiva",
  seconds: "segundos",
  buttonText: "Texto do botão",
  skipText: "Texto para pular",
  backgroundColor: "Cor de fundo",
  textColor: "Cor do texto",
  blurBackground: "Desfocar fundo",
  seconds5: "5 segundos",
  seconds10: "10 segundos",
  seconds15: "15 segundos",
  skipLabel: "Pular",
  continueLabel: "Continuar",
  playLabel: "Iniciar",
};

// Removed old salesNotification - now using dedicated file at categories/pt-BR/salesNotification.ts
